import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import App from './App.tsx';
import './index.css';
import './utils/instrument';
import './i18n/config';
import { QueryProvider } from '@api/QueryProvider';
import ErrorBoundary from './common/ErrorBoundary';

createRoot(document.getElementById('root')!, {
  onUncaughtError: import.meta.env.PROD
    ? Sentry.reactErrorHandler()
    : (error, errorInfo) => {
        console.error('Uncaught error:', error, errorInfo.componentStack);
      },
  onCaughtError: import.meta.env.PROD
    ? Sentry.reactErrorHandler()
    : (error, errorInfo) => {
        console.error('Caught error:', error, errorInfo.componentStack);
      },
  onRecoverableError: import.meta.env.PROD
    ? Sentry.reactErrorHandler()
    : (error, errorInfo) => {
        console.warn('Recoverable error:', error, errorInfo.componentStack);
      },
}).render(
  <StrictMode>
    <ErrorBoundary>
      <QueryProvider>
        <App />
      </QueryProvider>
    </ErrorBoundary>
  </StrictMode>
);
